import { StrictMode } from 'react'
import type { FC } from 'react'
import { ShadowElevation } from '@opallabs/gem'
import { ChildrenWithInjectedProps } from '@opallabs/lambda'
import * as styles from './styles'
import type { SidebarProps } from './types'

/**
 * Accessible sidebar. Use `<SidebarHeader>` and `<SidebarSection>` for the
 * sidebar’s contents.
 */
export const Sidebar: FC<React.PropsWithChildren<SidebarProps>> = ({
  children,
  className,
  elevation = ShadowElevation.E2,
  styleOverrides = {},
  theme = 'light',
}) => (
  <StrictMode>
    <section
      css={[
        styles.container({
          elevation,
          theme,
        }),
        styleOverrides,
      ]}
      role="complementary"
      {...{
        className,
      }}
    >
      <ChildrenWithInjectedProps
        {...{
          theme,
        }}
      >
        {children}
      </ChildrenWithInjectedProps>
    </section>
  </StrictMode>
)

Sidebar.displayName = 'Lapidary Unstable: Sidebar'

// Exports need to be at the end to make Storybook work
export { Header as SidebarHeader } from './Header'
export { Section as SidebarSection } from './Section'
